import { forEach } from "lodash";

export function addNoFollowAttribute() {
  const nodes = document.querySelectorAll(".story-element-text div p");

  forEach(nodes, function (node) {
    var anchors = node.getElementsByTagName("a");

    forEach(anchors, function (anchor) {
      if (anchor.hostname && anchor.hostname !== window.location.hostname) {
        anchor.setAttribute("rel", "nofollow");
        anchor.setAttribute("target", "_blank");
      }
    });
  });
}
